import { h, defineComponent } from 'vue';
import { useInspectionReport } from '@/ui/components/inspectionReport/useInspectioReport';
import { t } from '@/ui/i18n/i18n';
import { TableBoxHead } from '@/ui/components/inspectionReport/items/table/TableBoxHead';
import { Action } from '@/ui/components/inspectionReport/items/Action';

export const Issues = defineComponent({
  name: 'Issues',
  setup() {
    return function render() {
      const { resourceIssues } = useInspectionReport();

      if (!resourceIssues.value.length) {
        return null;
      }

      const title = `${t('inspection-report.actions')} (${resourceIssues.value.length})`;

      const shouldRenderApprovalStatus = resourceIssues.value.some(issue => issue.approvals_enabled);

      return h('div', {
        class: 'mb-4',
        attrs: { 'data-test': 'issues-div' },
      }, [
        h('span', { class: 'inspection-report__general-title font-semibold' }, [title]),
        h('table', { class: 'inspection-report__table mt-2' }, [
          h('tbody', [
            h('tr', [
              h(TableBoxHead, [t('inspection-report.action')]),
              h(TableBoxHead, [t('inspection-report.deadline')]),
              h(TableBoxHead, [t('inspection-report.assignee')]),
              h(TableBoxHead, [t('inspection-report.status')]),
              h(TableBoxHead, [t('inspection-report.priority')]),
              shouldRenderApprovalStatus
                ? h(TableBoxHead, [t('inspection-report.approval.status')])
                : null,
              h(TableBoxHead, [t('inspection-report.query')]),
            ]),
            resourceIssues.value.map(item => h(Action, {
              props: {
                item,
              },
            })),
          ]),
        ]),
      ]);
    };
  },
});
